export const PAYONEER_GET_EMPLOYEE_CONSENT = 'PAYONEER_GET_EMPLOYEE_CONSENT';
export const PAYONEER_SET_EMPLOYEE_CONSENT = 'PAYONEER_SET_EMPLOYEE_CONSENT';
export const PAYONEER_GET_EMPLOYEE_CONSENT_FAILED = 'PAYONEER_GET_EMPLOYEE_CONSENT_FAILED';